const containsData = (data) => {
  if (data) {
    if (Array.isArray(data)) {
      if (data.length) {
        return data;
      }
      return null;
    }
  }
  return data;
};

export const paidAdsState = {
  paid_ads_performance: [],
  paid_ads_mtm: [],
  paid_ads_ad_sources: [],
  paid_ads_matrix: [],
  paid_ads_campaigns: [],
  paidAdsData: {
    // facebook
    fbCampaigns: { headers: [], data: [], error: '' },
    fbCampaignsDateTwo: { headers: [], data: [], error: '' },
    // google adwords
    adwordsPerformance: {
      totals: {
        Clicks: { value: '' },
        Cost: { value: '' },
        Conversions: { value: '' },
        Cost_conv: { value: '' },
      },
      reports: [],
    },
    adwordsPerformanceDateTwo: {
      totals: {
        Clicks: { value: '' },
        Cost: { value: '' },
        Conversions: { value: '' },
        Cost_conv: { value: '' },
      },
      reports: [],
    },
    adwordsPerformanceMonthVsMonth: {
      totals: {
        Clicks: { value: '' },
        Cost: { value: '' },
        Conversions: { value: '' },
        Cost_conv: { value: '' },
      },
      reports: [],
    },
    MCC_Accounts: [],
    adwords_mcc_id: null,
    adSources: [],
    adwordsPerformanceAcctLevel: {
      totals: {
        start: {
          Clicks: { value: 0 },
          Cost: { value: 0 },
          Conversions: { value: 0 },
          Cost_conv: { value: 0 },
        },
        Clicks: { value: 0 },
        Cost: { value: 0 },
        Conversions: { value: 0 },
        Cost_conv: { value: 0 },
      },
    },
    facebookPerformanceAcctLevel: { headers: [], data: [], error: '' },
    adwordsStatsBarDaily: {
      dateOne: {
        Impressions: { data: [] },
        Conversions: { data: [] },
        Avg_CPC: { data: [] },
        Cost: { data: [] },
        Sales: { data: [] },
        roas: { data: [] },
        forms: { data: [] },
        Clicks: { data: [] },
        VideoViews: { data: [] },
        CTR: { data: [] },
        Phone_calls: { data: [] },
      },
      adValuesDateOne: {},
      dateTwo: {
        Impressions: { data: [] },
        Conversions: { data: [] },
        Avg_CPC: { data: [] },
        Cost: { data: [] },
        Sales: { data: [] },
        roas: { data: [] },
        forms: { data: [] },
        Clicks: { data: [] },
        VideoViews: { data: [] },
        CTR: { data: [] },
        Phone_calls: { data: [] },
      },
      adValuesDateTwo: {},
    },
    facebookAdsStatsBarDaily: {
      campaignDoesNotExistInDateRangeError: false,
      dateOne: {
        impressions: { data: [] },
        conversions: { data: [] },
        cpc: { data: [] },
        ctr: { data: [] },
        sales: { data: [] },
        roas: { data: [] },
        formleads: { data: [] },
        clicks: { data: [] },
        spend: { data: [] },
      },
      adValuesDateOne: {},
      dateTwo: {
        impressions: { data: [] },
        conversions: { data: [] },
        cpc: { data: [] },
        ctr: { data: [] },
        sales: { data: [] },
        roas: { data: [] },
        formleads: { data: [] },
        clicks: { data: [] },
        spend: { data: [] },
      },
      adValuesDateTwo: {},
    },
    adwordsAdGroups: [],
    facebookAdsets: [],
    facebookAdPreviews: [],
    facebookCampaigns: [],
    facebookCampaignsDateTwo: [],
    conversions: [],
    cost_conversion: [],
    cost: [],
    Total_conv_value: [],
    matrix: [],
  },
};

export const paidAdsReducer = {
  FETCHING_ADWORDS_PERFORMANCE_ACCT_LEVEL_SUCCESS: (state, payload) => {
    return {
      ...state,
      show: {
        ...state.show,
        paidAdsData: {
          ...state.show.paidAdsData,
          adwordsPerformanceAcctLevel: payload,
        },
      },
    };
  },
  FETCHING_FB_PERFORMANCE_ACCT_LEVEL_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      paidAdsData: {
        ...state.show.paidAdsData,
        facebookPerformanceAcctLevel: payload,
      },
    },
  }),
  FETCHING_FB_ADSETS_AD_PREVIEW_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      paidAdsData: {
        ...state.show.paidAdsData,
        facebookAdPreviews: [...state.show.paidAdsData.facebookAdPreviews, payload.data],
      },
    },
  }),

  FETCHING_ADWORDS_MCC_ACCOUNTS_SUCCESS: (state, payload) => {
    return {
      ...state,
      show: {
        ...state.show,
        paidAdsData: {
          ...state.show.paidAdsData,
          MCC_Accounts: payload,
        },
        data: {
          ...state.show.data,
          adwords_id: payload[0].id,
        },
      },
    };
  },

  FETCHING_FB_AD_CAMPAIGNS_DATE_TWO_SUCCESS: (state, payload) => {
    return {
      ...state,
      show: {
        ...state.show,
        paidAdsData: {
          ...state.show.paidAdsData,
          fbCampaignsDateTwo: payload,
        },
      },
    };
  },
  FETCHING_ADWORDS_PERFORMANCE_MONTH_VS_MONTH_SUCCESS: (state, payload) => {
    let final = payload;
    if (payload && (payload || {}).reports) {
      if (Array.isArray(payload.reports) && payload.reports.length) {
        const values = Object.values(payload.reports[0]);
        const count = (values || []).reduce((all, item) => {
          if (item === undefined) {
            all += 1;
          }
          return all;
        }, 0);
        if (count === 2) {
          final = null;
        }
      }
    }
    return {
      ...state,
      show: {
        ...state.show,
        paidAdsData: {
          ...state.show.paidAdsData,
          adwordsPerformanceMonthVsMonth: final || {
            totals: {
              Clicks: { value: null },
              Cost: { value: null },
              Conversions: { value: null },
              Cost_conv: { value: null },
            },
          },
        },
      },
    };
  },
  FETCHING_ADWORDS_PERFORMANCE_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      paidAdsData: {
        ...state.show.paidAdsData,
        adwordsPerformance: payload || {},
      },
    },
  }),
  FETCHING_ADWORDS_PERFORMANCE_DATE_TWO_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      paidAdsData: {
        ...state.show.paidAdsData,
        adwordsPerformanceDateTwo: payload,
      },
    },
  }),
  FETCHING_ADWORDS_AD_SOURCES_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      paidAdsData: {
        ...state.show.paidAdsData,
        adSources: payload,
      },
    },
  }),
  FETCHING_FACEBOOK_CAMPAIGNS_SUCCESS: (state, payload) => {
    return {
      ...state,
      show: {
        ...state.show,
        paidAdsData: {
          ...state.show.paidAdsData,
          facebookCampaigns: payload,
        },
      },
    };
  },
  FETCH_UPDATED_CAMPAIGN_VALUES_GOOGLE_SUCCESS: (state, payload) => {
    return {
      ...state,
      show: {
        ...state.show,
        paidAdsData: {
          ...state.show.paidAdsData,
          adwordsStatsBarDaily: {
            ...state.show.paidAdsData.adwordsStatsBarDaily,
            adValuesDateOne: { ...payload.data },
          },
        },
      },
    };
  },
  FETCH_UPDATED_CAMPAIGN_VALUES_FACEBOOK_SUCCESS: (state, payload) => {
    return {
      ...state,
      show: {
        ...state.show,
        paidAdsData: {
          ...state.show.paidAdsData,
          facebookAdsStatsBarDaily: {
            ...state.show.paidAdsData.facebookAdsStatsBarDaily,
            adValuesDateOne: { ...payload.data },
          },
        },
      },
    };
  },
  FETCH_UPDATED_CAMPAIGN_VALUES_GOOGLE_DATE_TWO_SUCCESS: (state, payload) => {
    return {
      ...state,
      show: {
        ...state.show,
        paidAdsData: {
          ...state.show.paidAdsData,
          adwordsStatsBarDaily: {
            ...state.show.paidAdsData.adwordsStatsBarDaily,
            adValuesDateTwo: { ...payload.data },
          },
        },
      },
    };
  },
  FETCHING_FB_ADSETS_SUCCESS: (state, payload) => {
    return {
      ...state,
      show: {
        ...state.show,
        paidAdsData: {
          ...state.show.paidAdsData,
          facebookAdsets: payload,
        },
      },
    };
  },
  FETCHING_ADWORDS_MTM_SUCCESS: (state, payload) => {
    return {
      ...state,
      show: {
        ...state.show,
        paidAdsData: {
          ...state.show.paidAdsData,
          conversions: payload.conversions,
          cost_conversion: payload.cost_conversion,
          cost: payload.cost,
          Total_conv_value: payload.Total_conv_value,
        },
      },
    };
  },
  FETCHING_ADWORDS_MATRIX_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      paidAdsData: {
        ...state.show.paidAdsData,
        matrix: payload,
      },
    },
  }),
  CRM_FETCH_PAID_ADS_PERFORMANCE_SUCCESS: (state, payload) => {
    return {
      ...state,
      paid_ads_performance: containsData(payload),
    };
  },
  CRM_FETCH_PAID_ADS_MTM_SUCCESS: (state, payload) => {
    return {
      ...state,
      paid_ads_mtm: containsData(payload),
    };
  },
  CRM_FETCH_PAID_ADS_AD_SOURCES_SUCCESS: (state, payload) => {
    return {
      ...state,
      paid_ads_ad_sources: containsData(payload),
    };
  },
  CRM_FETCH_PAID_ADS_MATRIX_SUCCESS: (state, payload) => {
    return {
      ...state,
      paid_ads_matrix: containsData(payload),
    };
  },
  CRM_FETCH_ADWORDS_CAMPAIGNS_SUCCESS: (state, payload) => {
    return {
      ...state,
      paid_ads_campaigns: containsData(payload),
    };
  },
  // Failed states
  CRM_FETCH_LEAD_INQUIRIES_FAIL: (state, payload) => {
    return {
      ...state,
      paid_ads_performance: 'failed',
    };
  },
  CRM_FETCH_PAID_ADS_MTM_FAIL: (state, payload) => {
    return {
      ...state,
      paid_ads_mtm: 'failed',
    };
  },
  CRM_FETCH_PAID_ADS_AD_SOURCES_FAIL: (state, payload) => {
    return {
      ...state,
      paid_ads_ad_sources: 'failed',
    };
  },
  CRM_FETCH_PAID_ADS_MATRIX_FAIL: (state, payload) => {
    return {
      ...state,
      paid_ads_matrix: 'failed',
    };
  },
  CRM_FETCH_PAID_ADS_CAMPAIGNS_FAIl: (state, payload) => {
    return {
      ...state,
      paid_ads_matrix: 'failed',
    };
  },
};
